module.exports = __webpack_public_path__ + "h5/img/mfe_18.683e2d01.jpg";